export default "__VITE_ASSET__511bfbc1__"